import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6255a417"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "me-0"
}
const _hoisted_2 = {
  class: "btn btn-icon btn-sm btn-light position-relative",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "left-start"
}
const _hoisted_3 = { class: "svg-icon svg-icon-3" }
const _hoisted_4 = {
  key: 0,
  class: "position-absolute top-0 start-100 translate-middle badge badge-sm badge-circle badge-primary"
}
const _hoisted_5 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px",
  "data-kt-menu": "true"
}
const _hoisted_6 = {
  class: "menu menu-rounded menu-column menu-title-gray-700 menu-icon-gray-400 menu-arrow-gray-400 menu-bullet-gray-400 menu-arrow-gray-400 menu-state-bg fw-semibold py-4",
  "data-kt-menu": "true"
}
const _hoisted_7 = {
  key: 0,
  class: "menu-item px-3",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "right-start"
}
const _hoisted_8 = {
  href: '#/order-overview/',
  class: "menu-link px-3"
}
const _hoisted_9 = { class: "menu-title text-line-clamp-1" }
const _hoisted_10 = {
  key: 0,
  class: "menu-sub menu-sub-dropdown py-4"
}
const _hoisted_11 = { class: "menu-title text-line-clamp-1" }
const _hoisted_12 = {
  key: 0,
  class: "menu-sub menu-sub-accordion pt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_common_tree_menu_item = _resolveComponent("common-tree-menu-item")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.trees && !(_ctx.trees instanceof Array))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/file-link.svg" })
          ]),
          (_ctx.treesNumber > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.treesNumber), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("a", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, "#" + _toDisplayString(_ctx.trees.request_number), 1)
                  ]),
                  (!(_ctx.trees.child instanceof Array))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_common_tree_menu_item, {
                          tree: _ctx.trees.child
                        }, null, 8, ["tree"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["menu-item menu-accordion show", {
            hover: _ctx.trees.current_request === 1,
          }])
            }, [
              _createVNode(_component_router_link, {
                class: "menu-link py-3",
                to: {
              name: _ctx.$route.name,
              params: {
                id: _ctx.trees.request_id,
              },
            },
                replace: "",
                "active-class": "m-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_11, "#" + _toDisplayString(_ctx.trees.request_number), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              (!(_ctx.trees.child instanceof Array))
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_common_tree_menu_item, {
                      tree: _ctx.trees.child
                    }, null, 8, ["tree"])
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}